import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, History, User } from "lucide-react";
import { DepositSheet } from "./DepositSheet";
import { SwapSheet } from "./SwapSheet";

const navbarStyle: React.CSSProperties = {
  height: "100vh",
  width: "60px",
  backgroundColor: "#FFFFFF",
  padding: "20px",
  boxShadow: "-2px 0 5px rgba(0,0,0,0.1)",
  zIndex: 1000,
  position: "fixed",
  right: 0,
  top: 0,
};

const ulStyle: React.CSSProperties = {
  listStyleType: "none",
  padding: 0,
  height: "100%",
  display: "flex",
  flexDirection: "column",
};

const liStyle: React.CSSProperties = {
  marginBottom: "30px",
  position: "relative",
};

const iconStyle: React.CSSProperties = {
  width: "24px",
  height: "24px",
};

const activeIconStyle: React.CSSProperties = {
  ...iconStyle,
  color: "#808080", // Grey color for active icon
};

const tooltipStyle = `
  .tooltip {
    position: relative;
  }
  .tooltip::after {
    content: attr(data-tooltip);
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    background-color: #333;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    white-space: nowrap;
    opacity: 0;
    transition: opacity 0.3s;
    pointer-events: none;
    margin-right: 10px;
  }
  .tooltip:hover::after {
    opacity: 1;
  }
`;

const mobileMediaQuery = `
  @media (max-width: 639px) {
    nav {
      height: 60px !important;
      width: 100% !important;
      bottom: 0 !important;
      top: auto !important;
      left: 0 !important;
      right: auto !important;
    }
    ul {
      flex-direction: row !important;
      justify-content: space-around !important;
      align-items: center !important;
    }
    li {
      margin-bottom: 0 !important;
    }
    .tooltip::after {
      top: auto !important;
      bottom: 100% !important;
      left: 50% !important;
      right: auto !important;
      transform: translateX(-50%) !important;
      margin-right: 0 !important;
      margin-bottom: 10px !important;
    }
  }
`;

const RightNavbar: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <style>{tooltipStyle}</style>
      <style>{mobileMediaQuery}</style>
      <nav style={navbarStyle}>
        <ul style={ulStyle}>
          <li style={liStyle}>
            <Link to="/" className="tooltip" data-tooltip="Home">
              <Home style={isActive("/") ? activeIconStyle : iconStyle} />
            </Link>
          </li>

          <li style={liStyle}>
            <div className="tooltip" data-tooltip="Deposit">
              <DepositSheet />
            </div>
          </li>

          <li style={liStyle}>
            <div className="tooltip" data-tooltip="Swap & Withdraw">
              <SwapSheet />
            </div>
          </li>

          <li style={liStyle}>
            <Link to="/history" className="tooltip" data-tooltip="History">
              <History
                style={isActive("/history") ? activeIconStyle : iconStyle}
              />
            </Link>
          </li>

          <li style={liStyle}>
            <Link to="/settings" className="tooltip" data-tooltip="Settings">
              <User
                style={isActive("/settings") ? activeIconStyle : iconStyle}
              />
            </Link>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default RightNavbar;
